<template lang="pug">
  div
    p.text-sm.text-gray-500(v-html="description")
    .flex.w-full.mt-1
      sw-button.btn-rounded-left(:class="buttonClasses" @click="decrementCounter") -
      sw-input(
        :custom-classes="customClasses"
        v-bind="{...$props, ...$attrs}"
        v-on="$listeners"
      )
      sw-button.btn-rounded-right(:class="buttonClasses" @click="incrementCounter") +
</template>

<script>
import SwInput from '../generic/SwInput';

export default {
  name: 'ProfilingTallyCounter',
  components: { SwInput },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: null,
    },
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 50,
    },
    description: {
      type: String,
      default: '',
    },
  },
  computed: {
    active () {
      return this.value || this.value === 0;
    },
    mainClasses () {
      return 'border-t border-b md:border-t-2 md:border-b-2 text-center md:leading-tight transition duration-200 ease-out focus:outline-none font-medium md:text-lg text-gray-700 placeholder-gray-250 h-12 md:h-16';
    },
    statusClasses () {
      if (this.error) return 'bg-red-100 hover:bg-white focus:bg-white border-red-500 hover:text-red-500 focus:text-red-500';
      if (this.active) return 'bg-green-150 hover:bg-white focus:bg-white border-green-900';
      return 'border-gray-300 bg-white hover:border-green-900 focus:border-green-900';
    },
    buttonClasses () {
      return `btn w-12 h-12 md:w-16 md:h-16 border md:border-2 ${this.buttonBorder}`;
    },
    buttonBorder () {
      if (this.error) return 'border-red-500';
      if (this.active) return 'border-green-900';
      return 'border-gray-300';
    },
    customClasses () {
      return `${this.mainClasses} ${this.statusClasses}`;
    },
  },
  methods: {
    decrementCounter () {
      if (this.value > this.minValue) this.$emit('decrement');
    },
    incrementCounter () {
      if (this.value < this.maxValue) this.$emit('increment');
    },
  },
};
</script>
